(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motionEnabled = document.documentElement.classList.contains('motion-enabled') && !reducedMotion;

  const progress = document.querySelector('[data-fk-progress]');
  let progressTimer;
  const setProgress = (active) => {
    if (!progress) return;
    clearTimeout(progressTimer);
    if (active) {
      progress.classList.add('is-active');
      progress.classList.remove('is-done');
    } else {
      progress.classList.add('is-done');
      progressTimer = setTimeout(() => progress.classList.remove('is-active', 'is-done'), 350);
    }
  };
  window.addEventListener('pageshow', () => setProgress(false));
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
    try {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.href !== location.href) setProgress(true);
    } catch (_) {}
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    form.setAttribute('aria-busy', 'true');
    setProgress(true);
  });

  // Loading state for media. Real images still use native loading="lazy" where appropriate.
  document.querySelectorAll('img').forEach((img) => {
    const parent = img.parentElement;
    if (!parent) return;
    const finish = () => {
      img.removeAttribute('data-fk-loading');
      parent.classList.remove('fk-media-loading');
    };
    if (img.complete) return finish();
    img.setAttribute('data-fk-loading', 'true');
    parent.classList.add('fk-media-loading');
    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
  });

  // Subtle reveal only on content groups, not every control.
  if (motionEnabled && 'IntersectionObserver' in window) {
    const candidates = document.querySelectorAll('.section-heading, .product-card, .editorial-card, .campaign-card, .image-text-media, .image-text-copy, .authenticity-card, .testimonials blockquote');
    candidates.forEach((node) => node.classList.add('motion-reveal'));
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -24px' });
    candidates.forEach((node) => observer.observe(node));
  }

  const drawer = document.getElementById('mobileDrawer');
  const menuButton = document.querySelector('.menu-toggle');
  const closeButton = document.querySelector('.drawer-close');
  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuButton?.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('drawer-open', open);
  };
  menuButton?.addEventListener('click', () => setDrawer(true));
  closeButton?.addEventListener('click', () => setDrawer(false));
  drawer?.addEventListener('click', (e) => { if (e.target === drawer) setDrawer(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setDrawer(false); });

  document.querySelectorAll('[data-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('.hero-slide')];
    const dots = [...carousel.querySelectorAll('[data-slide]')];
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const show = (i) => {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('active', n === current));
      dots.forEach((d, n) => d.classList.toggle('active', n === current));
    };
    const restart = () => {
      clearInterval(timer);
      if (reducedMotion) return;
      const ms = Number(carousel.dataset.autoplay || 6000);
      timer = setInterval(() => show(current + 1), ms);
    };
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slide)); restart(); }));
    restart();
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const main = button.closest('.product-gallery')?.querySelector('[data-gallery-main] img');
      if (main && button.dataset.image) main.src = button.dataset.image;
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const root = select.closest('.product-buy');
      const price = root?.querySelector('[data-price]');
      const compare = root?.querySelector('[data-compare-price]');
      const add = root?.querySelector('[data-add-to-cart]');
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (add) {
        const available = option.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? 'Adicionar à sacola' : 'Esgotado';
      }
    });
  });
})();

// FK Imports Motion System v2.5 — progressive enhancement, no external runtime.
(() => {
  const body = document.body;
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const enabled = root.classList.contains('motion-enabled') && !reduced;
  if (!enabled) return;

  const intensity = body.dataset.motionIntensity || 'dynamic';
  const strength = { subtle: 2, balanced: 3, dynamic: 4 }[intensity] || 3;
  const tiltMax = { subtle: 2.5, balanced: 4, dynamic: 5.5 }[intensity] || 4;

  // Stagger related content just enough to make sections feel composed.
  const setStagger = (scope = document) => {
    scope.querySelectorAll('.product-grid,.editorial-grid,.campaign-square-grid,.testimonials-grid,.olfactory-grid,.benefits-grid').forEach((group) => {
      [...group.children].forEach((item, index) => {
        item.style.setProperty('--fk-motion-delay', `${Math.min(index, 5) * 65}ms`);
      });
    });
  };
  setStagger();

  // Header reacts only when the page has actually moved.
  const header = document.querySelector('.site-header');
  let headerFrame = 0;
  const updateHeader = () => {
    headerFrame = 0;
    header?.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  window.addEventListener('scroll', () => {
    if (!headerFrame) headerFrame = requestAnimationFrame(updateHeader);
  }, { passive: true });
  updateHeader();

  // Parallax is intentionally limited to large visual assets and disabled on small/touch screens.
  const parallaxEnabled = body.dataset.motionParallax === 'true' && window.innerWidth >= 768;
  if (parallaxEnabled) {
    const parallaxItems = [...document.querySelectorAll('.hero-media, .campaign-wide .campaign-media')];
    let parallaxFrame = 0;
    const updateParallax = () => {
      parallaxFrame = 0;
      const viewport = window.innerHeight || 1;
      parallaxItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.bottom < -80 || rect.top > viewport + 80) return;
        const center = rect.top + rect.height / 2;
        const normalized = (center - viewport / 2) / viewport;
        const amplitude = item.classList.contains('hero-media') ? 20 : 12;
        const offset = Math.max(-amplitude, Math.min(amplitude, normalized * -amplitude));
        item.style.setProperty('--fk-parallax-y', `${offset.toFixed(2)}px`);
      });
    };
    const scheduleParallax = () => {
      if (!parallaxFrame) parallaxFrame = requestAnimationFrame(updateParallax);
    };
    window.addEventListener('scroll', scheduleParallax, { passive: true });
    window.addEventListener('resize', scheduleParallax, { passive: true });
    updateParallax();
  }

  // 3D depth only for precise desktop pointers. Uses one rAF per active card.
  const initTilts = (scope = document) => {
    if (!finePointer || body.dataset.motionTilt !== 'true') return;
    scope.querySelectorAll('[data-fk-tilt]:not([data-fk-tilt-ready])').forEach((card) => {
      card.dataset.fkTiltReady = 'true';
      let frame = 0;
      let nextX = 0;
      let nextY = 0;
      const render = () => {
        frame = 0;
        card.style.transform = `perspective(900px) rotateX(${nextY.toFixed(2)}deg) rotateY(${nextX.toFixed(2)}deg) translate3d(0,-2px,0)`;
      };
      card.addEventListener('pointerenter', () => card.classList.add('fk-tilting'));
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        nextX = x * tiltMax;
        nextY = y * -tiltMax;
        if (!frame) frame = requestAnimationFrame(render);
      });
      card.addEventListener('pointerleave', () => {
        if (frame) cancelAnimationFrame(frame);
        frame = 0;
        card.classList.remove('fk-tilting');
        card.style.transform = '';
      });
    });
  };
  initTilts();

  // Magnetic buttons move by only a few pixels: noticeable, but never interferes with clicking.
  const initMagneticButtons = (scope = document) => {
    if (!finePointer || body.dataset.motionMagneticButtons !== 'true') return;
    scope.querySelectorAll('.btn:not([disabled]):not([data-fk-magnetic-ready])').forEach((button) => {
      button.dataset.fkMagneticReady = 'true';
      let frame = 0;
      let x = 0;
      let y = 0;
      const render = () => {
        frame = 0;
        button.style.setProperty('--fk-mag-x', `${x.toFixed(2)}px`);
        button.style.setProperty('--fk-mag-y', `${y.toFixed(2)}px`);
      };
      button.addEventListener('pointermove', (event) => {
        const rect = button.getBoundingClientRect();
        x = ((event.clientX - rect.left) / rect.width - 0.5) * strength * 2;
        y = ((event.clientY - rect.top) / rect.height - 0.5) * strength * 1.5;
        if (!frame) frame = requestAnimationFrame(render);
      });
      button.addEventListener('pointerleave', () => {
        x = 0;
        y = 0;
        if (!frame) frame = requestAnimationFrame(render);
      });
    });
  };
  initMagneticButtons();

  // A lightweight radial cursor light on desktop. No blur or canvas, so GPU cost stays small.
  if (finePointer && body.dataset.motionCursorGlow === 'true' && intensity === 'dynamic') {
    const glow = document.createElement('div');
    glow.className = 'fk-cursor-glow';
    glow.setAttribute('aria-hidden', 'true');
    body.appendChild(glow);
    let cursorFrame = 0;
    let cursorX = -300;
    let cursorY = -300;
    const renderCursor = () => {
      cursorFrame = 0;
      glow.style.setProperty('--fk-cursor-x', `${cursorX}px`);
      glow.style.setProperty('--fk-cursor-y', `${cursorY}px`);
    };
    document.addEventListener('pointermove', (event) => {
      cursorX = event.clientX;
      cursorY = event.clientY;
      glow.classList.add('is-visible');
      if (!cursorFrame) cursorFrame = requestAnimationFrame(renderCursor);
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', () => glow.classList.remove('is-visible'));
  }

  // Shopify theme editor can replace sections without reloading the whole page.
  document.addEventListener('shopify:section:load', (event) => {
    const scope = event.target || document;
    setStagger(scope);
    initTilts(scope);
    initMagneticButtons(scope);
  });
})();

// FK Imports v2.6 — lightweight motion navigation rail and keyboard polish.
(() => {
  const nav = document.querySelector('[data-motion-nav]');
  if (!nav) return;
  const tabs = [...nav.querySelectorAll('.nav-tab')];
  const rail = nav.querySelector('.nav-motion-rail');
  if (!rail || !tabs.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let frame = 0;
  const positionRail = (tab, visible = true) => {
    if (!tab) {
      nav.style.setProperty('--nav-rail-opacity', '0');
      return;
    }
    const link = tab.querySelector('.nav-tab-link');
    if (!link) return;
    const navRect = nav.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();
    const inset = Math.min(18, linkRect.width * 0.12);
    nav.style.setProperty('--nav-rail-x', `${(linkRect.left - navRect.left + inset).toFixed(2)}px`);
    nav.style.setProperty('--nav-rail-width', `${Math.max(22, linkRect.width - inset * 2).toFixed(2)}px`);
    nav.style.setProperty('--nav-rail-opacity', visible ? '1' : '0');
  };

  const active = () => nav.querySelector('.nav-tab.is-active');
  const restore = () => positionRail(active(), Boolean(active()));
  tabs.forEach((tab) => {
    tab.addEventListener('pointerenter', () => positionRail(tab));
    tab.addEventListener('focusin', () => positionRail(tab));
    tab.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      tab.querySelector('.nav-tab-link')?.focus();
      positionRail(tab);
    });
  });
  nav.addEventListener('pointerleave', restore);
  nav.addEventListener('focusout', () => requestAnimationFrame(() => {
    if (!nav.contains(document.activeElement)) restore();
  }));
  window.addEventListener('resize', () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => { frame = 0; restore(); });
  }, { passive: true });

  // Avoid a staged first-paint movement when reduced motion is requested.
  if (reduced) nav.style.setProperty('--nav-rail-opacity', active() ? '1' : '0');
  restore();
})();
